// extracted by mini-css-extract-plugin
module.exports = {"legend":"Legend_legend__1toD4","legendHeaderContainer":"Legend_legendHeaderContainer__355T6","legendChildrenContainer":"Legend_legendChildrenContainer__24t-T"};